(ns minorodata.connections.sources.partnerize
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "partnerize"
   :enabled      false
   :name         "Partnerize (Legacy)"
   :description  "A Partner Management Platform system that helps brands build powerful business partnerships and growth"
   :image-source "PartnerizeLogo2021.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
              (fn [data]
                (let [{:keys [name description username password partner-id]} data]
                  {:source-type "partnerize"
                   :name        name
                   :description description

                   :source
                                {:credentials         {:username  username
                                                       :password  password
                                                       :partner-id partner-id}}}))

    :format-for-inputs
              (fn [data]
                (let [{:keys [source name description]} data
                      {:keys [credentials]} source]
                  (merge
                    (select-keys credentials [:username :password :partner-id])
                    {:name              name
                     :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :partnerize-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Username"
              :required   true
              :name       :username
              :value      ""}
             {:block-type :input
              :label      "Password"
              :required   true
              :name       :password
              :type       :password
              :value      ""}

             {:block-type :input
              :label      "Partner ID"
              :required   true
              :name       :partner-id
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
              (fn [{:keys [name description status action destination-table
                           report campaign-id at-date extract-type start-date end-date]}]
                {:name          name
                 :description   description
                 :status        status
                 :output-tables [destination-table]

                 :config
                 {:extracts [{:report            report
                              :campaign-id       campaign-id
                              :at-date           at-date
                              :extract-type      extract-type
                              :start-date        start-date
                              :end-date          end-date
                              :destination-table destination-table
                              :action            action}]}})

    :format-for-inputs
              (fn [data]
                (let [{:extract/keys [name description status config]} data

                      extract (get-in config [:extracts 0])]
                  (merge
                    (select-keys extract [:report :action :campaign-id :at-date :extract-type :start-date :end-date :destination-table])
                    (app.utils/keep-non-nil-keys
                      {:name          name
                       :description   description
                       :status        status}))))

    :validate (constantly nil)

    :id :partnerize-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report type"
              :name       :report
              :options    [{:name "Commissions"          :value "commissions"}
                           {:name "Conversions"          :value "conversions"}
                           {:name "Selfbills"            :value "selfbills"}]
              :required   true
              :value      "commissions"}

             {:block-type :input
              :label      "Campaign ID"
              :name       :campaign-id
              :conditions [[:eq [:report :value]  "commissions"]]}


             {:block-type :date-picker
              :label "At"
              :name :at-date
              :required false
              :conditions [[:eq [:report :value] "commissions"]]}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Incremental" :value "incremental"}
                           {:name "Full"        :value "backfill"}]
              :required   true
              :value      ""
              :conditions [[:eq [:report :value] "conversions"]]}

             {:block-type :date-picker
              :label "From"
              :name :start-date
              :required false
              :conditions [[:and [[:extract-type :value] [:report :value]] ["backfill" "conversions"]]]}

             {:block-type :date-picker
              :label "To"
              :name :end-date
              :required false
              :conditions [[:and [[:extract-type :value] [:report :value]] ["backfill" "conversions"]]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "backfill"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
